import {OnlyInLoginChecker} from '../../../../../../common/checkers/OnlyInLoginChecker';
import {ScheduledLastPageFetcher} from '../../../../../../common/fetchers/ScheduledLastPageFetcher';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {MAX_PROGRESS_RATE} from '../constant/viewerConstant';
import {convertToLastViewRate} from '../util/convertToLastViewRate';

export interface ViewerProgressContainerProps {
  seriesId: number;
  productId: number;
}

/**
 * 이미지 뷰어의 진행도 저장/로드를 지원하기 위한 컨테이너입니다.
 */
export function ViewerProgressContainer({
  seriesId,
  productId,
}: ViewerProgressContainerProps) {
  const currentPage = useTypedSelector(
    state => state.imageViewer.viewData[productId]?.currentPage || 0
  );
  const totalPage = useTypedSelector(
    state => state.imageViewer.viewData[productId]?.totalPage || 0
  );

  const isViewerEnd = useTypedSelector(
    state => state.imageViewer.viewData[productId]?.isViewerEnd || false
  );
  const isTwoPageLayout = useTypedSelector(
    state => state.imageViewer.settings.isTwoPageLayout
  );

  const rate = convertToLastViewRate({
    position: currentPage,
    total: totalPage,
  });

  return (
    <OnlyInLoginChecker>
      {rate !== undefined && (
        <ScheduledLastPageFetcher
          seriesId={seriesId}
          productId={productId}
          rate={rate}
          spineIndex={isViewerEnd ? 1 : 0}
          isDone={
            convertToLastViewRate({
              position: currentPage,
              total: totalPage,
              isTwoPageLayout,
            }) === MAX_PROGRESS_RATE
          }
        />
      )}
    </OnlyInLoginChecker>
  );
}
